import { FacultyMember } from 'types';

export default (facultyMembers: FacultyMember[]) => {
  return facultyMembers.sort((a, b) => a.lastName.localeCompare(b.lastName));
};
